import moment from 'moment'

export function checkRoundTime(start_t,end_t){
    let n = moment(),
        status = 'un_start'
    if(n.isBefore(start_t)){
        status = 'un_start'
    }else if(n.isAfter(end_t)){
        status = 'end'
    }else{
        status = 'inTime'
    }
    return status;
}


